import {useEffect, useState} from "react";
import {animated, useSpring} from "@react-spring/web";
import styles from "../marketing.module.scss";
import sec17_alphabet02 from '../../../../resources/img/Events/Marketing/sec17_alphabet02_m.png';

export const Section17 = (props) => {
    const [frame, setFrame] = useState(0)
    const spring = useSpring({ x: frame })

    useEffect(() => {
        if (!props.ranges?.length || props.ranges[0].length < 2) return
        const currentFrame = props.run(props)
        setFrame(currentFrame)
    }, [props.pageYOffset, props.innerHeight])

    return (
        <animated.div className={styles['animation-container']} style={{
            opacity: spring.x.to({
                range: props.section.opacityRange as number[],
                output: props.section.opacityOutput as number[]
            }).to(x => x),
        }}>
            <div className={`${styles.sec} ${styles.sec17} ${styles['dark-gray']}`}>
                <a href='#' className={`${styles.sec17__card} ${styles.ab}`} target="_blank">
                    <p className={`${styles.sec17__card__font01} ${styles.averta} ${styles.marginDel}`}>event</p>
                    <p className={`${styles.sec17__card__font02} ${styles.marginDel}`}>확 바뀐 빗썸!</p>
                    <div className={styles.sec17__card__p01}>
                        <p className={`${styles.sec17__card__p01__font03} ${styles.marginDel} ${styles.notoBold}`}>체험하면</p>
                        <p className={`${styles.sec17__card__p01__font0301} ${styles.marginDel} ${styles.notoBold}`}>총</p>
                        <p className={`${styles.sec17__card__p01__font04} ${styles.marginDel} ${styles.averta}`}>1</p>
                        <p className={`${styles.sec17__card__p01__font05} ${styles.marginDel} ${styles.notoBold}`}>억원 혜택</p>
                    </div>
                    <div className={styles.sec17__card__p02}>
                        <p className={`${styles.sec17__card__p02__font06} ${styles.averta} ${styles.marginDel}`}>100</p>
                        <p className={`${styles.sec17__card__p02__font07} ${styles.averta} ${styles.marginDel}`}>,</p>
                        <p className={`${styles.sec17__card__p02__font06} ${styles.averta} ${styles.marginDel}`}>000</p>
                        <p className={`${styles.sec17__card__p02__font07} ${styles.averta} ${styles.marginDel}`}>,</p>
                        <p className={`${styles.sec17__card__p02__font06} ${styles.averta} ${styles.marginDel}`}>000</p>
                    </div>
                    <div className={styles.sec17__card__go}>
                        <p className={`${styles.sec17__card__go__font} ${styles.averta} ${styles.marginDel}`}>GO&#33;</p>
                    </div>
                </a>
                <animated.img className={`${styles.sec17__img02} ${styles.ab}`} src={sec17_alphabet02} alt="알파벳 묶음2" style={{
                    translateY: spring.x.to({
                        range: [0, 0.15, 1],
                        output: [-30, 0, 0]
                    }).to(x => `${x}vh`)
                }} />
                <span className={`${styles.sec17__circle01} ${styles.ab}`}></span>
            </div>
        </animated.div>
    )
}